import PropTypes from 'prop-types';
import values from 'lodash/fp/values';

import { AudienceScope } from 'common/types/view';

/**
 * Describes an "audience scope"; used mainly for the AudienceLabel component
 */
export default PropTypes.oneOf(values(AudienceScope));
